import * as React from "react";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { TableContext } from "../table/table.mjs";
const TableCell = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React.createElement(TableCellResponsive, { ...rest, responsive }) : /* @__PURE__ */ React.createElement(TableCellInner, { ...rest });
};
const TableCellResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React.createElement(TableCellInner, { ...rest, ...responsiveProps });
};
const TableCellInner = (props) => {
  const { type = "td", width, padding, indentLevel, valign, background, className, id, colSpan, rowSpan, headless, scope, children } = props;
  const { cellPadding } = React.useContext(TableContext);
  const tableCellPadding = cellPadding != null ? cellPadding : padding;
  const Element = type;
  const BEM = () => {
    const classArray = ["table__cell"];
    if (width) {
      classArray.push("table__cell--".concat(width));
    }
    if (tableCellPadding) {
      classArray.push("table__cell--padding-".concat(tableCellPadding));
    }
    if (indentLevel) {
      classArray.push("table__cell--indent-level-".concat(indentLevel));
    }
    if (valign) {
      classArray.push("table__cell--valign-".concat(valign));
    }
    if (background && background !== "transparent") {
      classArray.push(getBackgroundColorClass(background));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(Element, { className: BEM(), id, colSpan, rowSpan, "data-headless": headless, scope: type === "th" ? scope : void 0 }, children);
};
export {
  TableCell
};
